import { render, staticRenderFns } from "./bullet.vue?vue&type=template&id=394980f2"
import script from "./bullet.vue?vue&type=script&lang=js"
export * from "./bullet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports